const STORAGE_KEY = 'cookie_consent_v1';

export function getCookieConsent() {
  try {
    const v = window.localStorage.getItem(STORAGE_KEY);
    return v === 'accepted' || v === 'rejected' ? v : null;
  } catch {
    return null;
  }
}

export function setCookieConsent(value) {
  try {
    window.localStorage.setItem(STORAGE_KEY, value);
  } catch {
    // ignore
  }
}

export function shouldEnableAnalytics() {
  return getCookieConsent() === 'accepted';
}

export function initCookieConsentBanner() {
  const banner = document.getElementById('cookie-consent');
  if (!banner) return;

  // In horizontal mode we pin/wrap the whole body; ensure banner is outside that wrapper
  // so `position: fixed` is relative to the viewport and above hero video layers.
  try {
    const pinWrapper = document.getElementById('horizontal-scroll-pin-wrapper');
    if (pinWrapper && pinWrapper.contains(banner)) {
      document.body.appendChild(banner);
    }
  } catch {
    // ignore
  }

  // Guard: if the pin wrapper is created later and swallows the banner, move it back out.
  try {
    if (!window.__cookieConsentPinnedGuard) {
      window.__cookieConsentPinnedGuard = true;
      const mo = new MutationObserver(() => {
        const pinWrapper = document.getElementById('horizontal-scroll-pin-wrapper');
        const banner = document.getElementById('cookie-consent');
        if (pinWrapper && banner && pinWrapper.contains(banner)) {
          document.body.appendChild(banner);
        }
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
    }
  } catch {
    // ignore
  }

  const consent = getCookieConsent();
  if (consent) {
    banner.setAttribute('hidden', 'hidden');
    return;
  }

  // No stored choice yet: show banner
  banner.removeAttribute('hidden');

  const acceptBtn = banner.querySelector('[data-cookie-action="accept"]');
  const rejectBtn = banner.querySelector('[data-cookie-action="reject"]');

  function hide() {
    banner.setAttribute('hidden', 'hidden');
  }

  if (acceptBtn) {
    acceptBtn.addEventListener('click', () => {
      setCookieConsent('accepted');
      window.dispatchEvent(new CustomEvent('cookieConsentChanged', { detail: { value: 'accepted' } }));
      hide();
    });
  }

  if (rejectBtn) {
    rejectBtn.addEventListener('click', () => {
      setCookieConsent('rejected');
      window.dispatchEvent(new CustomEvent('cookieConsentChanged', { detail: { value: 'rejected' } }));
      hide();
    });
  }
}

